import { Plug, CheckCircle2, KeyRound, Unplug, Zap, RefreshCw } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export function ConnectionSection({
  isConnected, connection, company, companyId, period, canMappingWrite,
  syncing, onOpenWizard, onRealSync, onOpenRotate, onOpenDisconnect,
}) {
  if (!isConnected) {
    return (
      <Card className="border-slate-200" data-testid="connection-setup-card">
        <CardContent className="p-5 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <Plug className="w-5 h-5 text-slate-500 mt-0.5" aria-hidden="true" />
            <div>
              <p className="text-sm font-semibold text-slate-900">JOBTIMEHR non collegato</p>
              <p className="text-xs text-slate-600 leading-relaxed max-w-xl">
                Collega l'API di integrazione ESG v1 di JOBTIMEHR (OAuth2 client credentials, read-only).
                Le credenziali sono cifrate e usate solo dal backend: non verranno mai mostrate né inviate al browser.
              </p>
            </div>
          </div>
          {canMappingWrite && (
            <Button className="bg-green-700 hover:bg-green-800" onClick={onOpenWizard} data-testid="connect-button">
              <Plug className="w-4 h-4 mr-1" aria-hidden="true" /> Collega JOBTIMEHR
            </Button>
          )}
        </CardContent>
      </Card>
    );
  }
  return (
    <Card className="border-green-300 bg-green-50" data-testid="connection-card">
      <CardContent className="p-5">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div className="space-y-1.5 text-sm">
            <p className="font-semibold text-green-900 flex items-center gap-2">
              <CheckCircle2 className="w-4 h-4" aria-hidden="true" /> Connessione attiva
            </p>
            <p className="text-xs text-green-800">
              <span className="font-semibold">Company mapping:</span> ESG: {company?.name || companyId}
              {" "}↔ JOBTIMEHR: <span className="font-mono">{connection.external_company_id}</span>
            </p>
            <p className="text-xs text-green-800">
              API {connection.api_version} · {connection.base_url} · sync {connection.sync_frequency}
              {connection.status === "DEGRADED" && " · ATTENZIONE: errori recenti (stato DEGRADED)"}
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button size="sm" className="bg-green-700 hover:bg-green-800" onClick={() => onRealSync("FULL")}
              disabled={syncing || !period} data-testid="real-sync-full">
              <Zap className="w-4 h-4 mr-1" aria-hidden="true" /> Sync completa ({period?.year})
            </Button>
            <Button size="sm" variant="outline" onClick={() => onRealSync("INCREMENTAL")}
              disabled={syncing || !period} data-testid="real-sync-incremental">
              <RefreshCw className="w-4 h-4 mr-1" aria-hidden="true" /> Sync incrementale
            </Button>
            {canMappingWrite && (
              <>
                <Button size="sm" variant="outline" onClick={onOpenRotate} data-testid="rotate-button">
                  <KeyRound className="w-4 h-4 mr-1" aria-hidden="true" /> Aggiorna credenziali
                </Button>
                <Button size="sm" variant="outline" className="text-red-700 border-red-300" onClick={onOpenDisconnect} data-testid="disconnect-button">
                  <Unplug className="w-4 h-4 mr-1" aria-hidden="true" /> Scollega
                </Button>
              </>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
